import React from 'react';

import NavDropdown from 'react-bootstrap/NavDropdown';
import {getCustomerName,logout} from './utils'

function UserProfile(props) {
  var customerName ="Hello, "+ getCustomerName();

  return (
    <NavDropdown title={customerName} id="basic-nav-dropdown">
      <NavDropdown.Item onClick={logout}>Logout</NavDropdown.Item> 
    </NavDropdown>
  );
}
export default UserProfile